module.exports = __webpack_public_path__ + "img/track.14924778.png";